import "./index.css";
import React from "react";
import { render } from "react-dom";
import App from "./App";
render(<App data-id="element-152" data-mp="1wausa6zkfour" />, document.getElementById("root"));